import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import axiosInstance from "../../../axios/axiosInstance";
import { handeleUpdateStatus } from "../../../utils/update-request-status";

interface Prop {
  requestData?: any;
  onClose?: () => void;
  requestId?: any;
}

const DeleteZone: React.FC<Prop> = ({ requestData, onClose, requestId }) => {
  const [zone, setZone] = useState<any>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (requestData?.data?.id) {
      fetchZone(requestData.data.id);
    }
  }, [requestData]);

  const fetchZone = async (id: number) => {
    setLoading(true);
    try {
      const resp: any = await axiosInstance.get(`/api/zone/${id}`);
      if (resp.status === 200) {
        setZone(resp?.data?.data);
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || "Error fetching zone details");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async () => {
    try {
      if (!requestData?.data?.id) {
        toast.error("Zone ID is missing");
        return;
      }

      // When approving, execute directly without invocation
      const resp: any = await axiosInstance.delete(
        `/api/zone/${requestData.data.id}`
      );
      
      if (resp.status === 200) {
        if (requestId) {
          handeleUpdateStatus(requestId, "1");
        }
        toast.success("Request approved and zone deleted successfully");
        onClose?.();
      }
    } catch (error: any) {
      toast.error(error?.response?.data?.body || error?.message || "Error deleting zone");
    }
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center py-8">
          <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-600"></div>
        </div>
        <p className="text-center text-gray-600 dark:text-gray-300">Loading zone details...</p>
      </div>
    );
  }

  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-2">
          Approve Zone Deletion
        </h2>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Review the zone details below before approving deletion.
        </p>
      </div>

      {zone ? (
        <div className="space-y-4">
          <div className="p-4 bg-red-50 dark:bg-red-900/20 border border-red-200 dark:border-red-800 rounded-lg">
            <h3 className="text-sm font-semibold text-red-800 dark:text-red-300 mb-3">
              Zone to be Deleted
            </h3>
            <div className="space-y-2 text-sm">
              <div>
                <span className="font-semibold text-gray-700 dark:text-gray-300">Zone Name:</span>
                <span className="ml-2 text-gray-900 dark:text-white">{zone.zone_name}</span>
              </div>
              <div>
                <span className="font-semibold text-gray-700 dark:text-gray-300">Area:</span>
                <span className="ml-2 text-gray-900 dark:text-white">{zone.zone_area || "N/A"}</span>
              </div>
              {zone.leader && (
                <div>
                  <span className="font-semibold text-gray-700 dark:text-gray-300">Leader:</span>
                  <span className="ml-2 text-gray-900 dark:text-white">{zone.leader.name}</span>
                </div>
              )}
            </div>
          </div>

          <div className="flex justify-end gap-3 pt-4 border-t border-gray-200 dark:border-gray-700">
            <button
              onClick={onClose}
              className="btn-primary px-6 py-2.5"
            >
              Cancel
            </button>
            <button
              onClick={handleDelete}
              className="btn-primary px-6 py-2.5 bg-red-600 hover:bg-red-700"
            >
              Approve & Delete
            </button>
          </div>
        </div>
      ) : (
        <div className="text-center py-8">
          <p className="text-gray-600 dark:text-gray-300">Zone details not available</p>
        </div>
      )}
    </div>
  );
};

export default DeleteZone;
